import { I18n } from '@aws-amplify/core';
import { useMemo } from 'react';

type KimRiskMessages = {
	risk_level: string;
	health_consequences: string;
	measures: string;
};

export const KIM_LHC_RISK = {
	LOW: 'LOW',
	SLIGHTLY_INCREASED: 'SLIGHTLY_INCREASED',
	SUBSTANTIALLY_INCREASED: 'SUBSTANTIALLY_INCREASED',
	HIGH: 'HIGH'
};

export function useGetSummaryMessages(risk: string): KimRiskMessages {
	return useMemo(() => {
		if (risk === KIM_LHC_RISK.LOW) {
			return {
				risk_level: I18n.get('Physical overload is unlikely'),
				health_consequences: I18n.get('No health risks are expected'),
				measures: I18n.get('No action is required')
			};
		}

		if (risk === KIM_LHC_RISK.SLIGHTLY_INCREASED) {
			return {
				risk_level: I18n.get('Possible for less resilient individuals'),
				health_consequences: I18n.get(
					'Fatigue, low-level adaptation issues that can be compensated during down time'
				),
				measures: I18n.get(
					'For less resilient individuals, workplace redesign and other preventive measures may be helpful'
				)
			};
		}

		if (risk === KIM_LHC_RISK.SUBSTANTIALLY_INCREASED) {
			return {
				risk_level: I18n.get('Physical overload is also possible even for normally resilient individuals'),
				health_consequences: I18n.get(
					'Disorders (pain), possibly including dysfunctions, reversible in most cases, without morphological manifestation'
				),
				measures: I18n.get('Workplace redesign measures and other preventive measures must be considered')
			};
		}

		if (risk === KIM_LHC_RISK.HIGH) {
			return {
				risk_level: I18n.get('Physical overload is likely'),
				health_consequences: I18n.get(
					'More pronounced disorders and/or dysfunctions, with structural damage of pathological relevance'
				),
				measures: I18n.get(
					'Workplace redesign measures are necessary. Other preventive measures must be considered'
				)
			};
		}

		return {
			risk_level: '',
			health_consequences: '',
			measures: ''
		};
	}, [risk]);
}
